import 'COMMON';
import 'Bem/site/accordion/accordion';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import { speed } from 'Lib/speed/speed';
import 'Vendor/owlcarousel/owl.carousel.min';
import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';

svgSpriteLoader('/landing/career/svg/sprite.svg?v=20190218');

const $slider = $('.career__h-gallery-slider');
const $gallery = $('.career__gallery-slider');
const cSliderOn = 'owl-carousel';
const cCityLickActive = 'drop-down__item_active';
const cCityContActive = 'career__tags-cont_active';
const $cityLick = $('.career .drop-down__item');

$slider.each(function (evt) {
    const e = parseInt(evt);
    const $this = $(this);

    if ($this.find('.career__h-gallery-item').length > 1) {
        let cArrows = 'career__h-gallery-arrows';
        let cDots = 'career__h-gallery-dots';
        const $arrows = $this.siblings(`.${cArrows}`);
        const $dots = $this.siblings(`.${cDots}`);

        cArrows += e;
        cDots += e;
        $arrows.addClass(cArrows);
        $dots.addClass(cDots);

        $this.trigger('destroy.owl.carousel')
            .removeClass(cSliderOn)
            .addClass(cSliderOn)
            .owlCarousel({
                items: 1,
                slideBy: 1,
                autoWidth: true,
                smartSpeed: speed * 2,
                dotsContainer: `.${cDots}.dots`,
                dotClass: 'dots__item',
                navContainer: `.${cArrows}`,
                navClass: ['career__h-gallery-prev arrow arrow_prev', 'career__h-gallery-next arrow arrow_next'],
                navText: ['', ''],
                margin: 15,
                responsive: {
                    770: { nav: true, autoWidth: false, margin: 0, mouseDrag: false },
                },
            });
    }
});

$gallery.each(function (evt) {
    const e = parseInt(evt);
    const $this = $(this);

    if ($this.find('.career__gallery-item').length > 1) {
        let cArrows = 'career__gallery-arrows';
        let cDots = 'career__gallery-dots';
        const $arrows = $this.siblings(`.${cArrows}`);
        const $dots = $this.siblings(`.${cDots}`);

        cArrows += e;
        cDots += e;
        $arrows.addClass(cArrows);
        $dots.addClass(cDots);

        $this.trigger('destroy.owl.carousel')
            .removeClass(cSliderOn)
            .addClass(cSliderOn)
            .owlCarousel({
                items: 1,
                slideBy: 1,
                loop: true,
                smartSpeed: speed * 2,
                dotsContainer: `.${cDots}.dots`,
                dotClass: 'dots__item',
                navContainer: `.${cArrows}`,
                navClass: ['career__gallery-prev arrow arrow_prev', 'career__gallery-next arrow arrow_next'],
                navText: ['', ''],
                margin: 15,
                responsive: {
                    770: { margin: 30, mouseDrag: false },
                },
            });
    }
});

$cityLick.on('click', function (e) {
    e.preventDefault();

    const $this = $(this);

    if (!$this.hasClass(cCityLickActive)) {
        const id = parseInt($this.attr('data-id'));
        const name = $this.text();

        if (id) {
            const $conts = $this.closest('.career__s-tags').find('.career__tags-cont');

            if ($conts.length) {
                $cityLick.removeClass(cCityLickActive);
                $this.addClass(cCityLickActive);
                $conts.removeClass(cCityContActive);
                $conts.filter(`[data-id=${id}]`).first().addClass(cCityContActive);

                if (isNoEmptyString(name)) {
                    $this.closest('.career__tags-description').find('.career__tags-description-drop-text').html(name);
                }
            }
        }
    }
});